// Component to render the profile card
// Import react
import React, { useState, useEffect } from "react";


import Select from "../dropdown/muiDropdown";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';

// Import supabase configuration
import supabase from "../../config/supabase";
import { useRef } from "react";
// Import button
import { Buffer } from "buffer";
import Button from "../../components/button/button";

const paymentTypeList = [{
    value: "Hourly",
    label: "Hourly"
  },
  {
    value: "Monthly",
    label: "Monthly"
  },
  {
    value: "Yearly",
    label: "Yearly"
  }
  ]

export default function Profile({
  profile,
  getId,
  currentProfile,
  onChangeDelete,boardProfiles,editClientRate, selectPaymentFrequency
}) {

  const [url, setUrl] = useState("/blurry.svg");
  const [showInputBox, setShowInputBox] = useState(false);
  const [clientRate, setRate] = useState("");
  const [paymentType, setPaymentType] = useState("");

  useEffect(() => {
    var rate = boardProfiles?.find(p => profile.id == p.id).rate;
    setRate(rate);
    var paymentFrequency = boardProfiles?.find(p => profile.id == p.id).paymentFrequency;
    paymentFrequency = { value : paymentFrequency, label : paymentFrequency};
    switch (paymentFrequency.value) {
        case 'Hourly':
            setPaymentType(paymentTypeList[0]);
            break;
        
        case 'Monthly':
            setPaymentType(paymentTypeList[1]);
            break;
        
        case 'Yearly':
            setPaymentType(paymentTypeList[2]);
            break;
            
        default:
            setPaymentType(paymentTypeList[0]);
            break;
        }
    },[])

    const onChange = (e) => {
        onChangeDelete(e, profile.id);
    }

    const editRate = (e,id,type) => {
        setRate(e.target.value);
        if (e.keyCode === 13 || type== "blur") {
            if(editClientRate){
                setShowInputBox(false);
                editClientRate(e.target.value,id)
            }
        }
    }

  const handleOnClick = (e) => {
    getId(e, profile.id);
  }

  const onChangeEvent = (value, id) => {
    setPaymentType(value);
    selectPaymentFrequency(value, id)
  }

  return (
    // Function to render the content
    <div className="w-full h-auto relative container cursor-pointer" onClick={(e) => handleOnClick(e)}>
      {/* show image if profile is scheduled */}

      {/* Add card */}
      <div className={`rounded bg-white-1 shadow-clientCard h-auto grid grid-cols-12 gap-3 p-6 box-border ${currentProfile == profile ? 'border-blue-1 border-2' : ''} `}>

        {/* Column for avatar */}
        <div className="col-span-12 sm:col-span-3 lg:col-span-2 flex items-center relative h-emoji w-emoji pt-10">
        {/* Render image if provided */}
        {profile.emoji_url ? (
            // Render imgae
            <img className="" src={profile?.emoji_url ? profile.emoji_url : url} />
        ) : (
            // Render placeholder
            <div className="w-emoji h-emoji bg-white-3 flex items-center">
            {/* Render text */}
            <div className="text-center w-full text-md font-text text-white-1 font-medium">
                {profile.full_name && profile.full_name[0].toUpperCase()}
            </div>
            </div>
        )}
        </div>

        {/* Column for details */}
        <div className="col-span-12 sm:col-span-9 lg:col-span-10 grid grid-cols-12 gap-1">
        {/* Column for name and email*/}
        <div className="flex justify-between content-center col-span-12">
            {/* Render name */}
            <div className="w-full text-lg font-text text-black-1 font-normal">
            {profile.full_name}
            </div>
            
            {/* Render remove button */}
            {profile.expected_hourly_rate ? (
            <div className="w-full text-sm font-semibold text-black-1 flex content-center justify-end">
                <div className="text-black-1 text-xs font-normal flex items-center" onClick={(e) => onChange(e)}>
                    <DeleteOutlineRoundedIcon className="text-black-1 mr-1.5" sx={{ fontSize: 17 }} />
                        Remove
                        </div>
                {/* Text */}
            </div>
            ) : null}
        </div>

        {/* Column for email and exp */}
        <div className="col-span-12 lg:col-span-6">
            {/* Render email */}
            {profile.email ? (
            <div className="w-full mb-4 text-sm font-light text-black-1 flex items-center">
 
                {/* email  */}
                {profile.email} 
            </div>
            ) : null}

            {/* Render exp */}
            {profile.exp ? (
            <div className="w-full text-xs font-normal text-black-2">
                <div>EXPERIENCE</div>
                <div className="text-black-1 text-sm font-semibold">
                {/* Text */}
                {profile.exp} Years
                </div>
            </div>
            ) : null}
        </div>

        {/* Column for experience and contract */}
        <div className="col-span-12 lg:col-span-4">
            {/* Render exp */}
            
            {/* Render expected_hourly_rate */}
            {profile.expected_hourly_rate ? (
            <div className="w-full text-sm font-semibold text-black-1 mt-8">
                <div className="text-black-2 text-xs font-normal"> HOURLY RATE</div>
                {/* Text */}
                <div>${profile.expected_hourly_rate}</div>
            </div>
            ) : null}
        </div>

        </div>

        {/* Add space */}
        <div className="hidden md:block col-span-2"></div>

        {/* Show client pricing and remove */}
        <div className="col-span-12 lg:col-span-5">
            {/* Render exp */}
            
            {/* Render expected_hourly_rate */}
            {profile.expected_hourly_rate ? (
            <div className="w-full text-sm font-semibold text-black-1">
                <div className="text-black-2 text-xs font-normal"> CLIENT RATE</div>
                {/* Text */}
                <div>{
							showInputBox ?
							<input type="number" value={clientRate} autoFocus onChange={(e) => editRate(e,profile.id,"")} onKeyDown={(e) => e.keyCode === 13 && editRate(e,profile.id,"enter")} onBlur={(e) => editRate(e,profile.id,"blur")} style={{"textAlign":'center', "color" : "black"}} className=" bg-white-7 border border-blue-1 w-16 h-7 flex items-center rounded focus:border-blue-1 focus:border-2 focus:outline-none" />  
							: <div  className="cursor-pointer flex mr-1 mt-2"><img src="/edit3.svg" onClick={()=> setShowInputBox(true)} />
								<span className="font-semibold text-black-1 ml-3"> ${new Intl.NumberFormat().format(clientRate)}</span>	
							</div>
						}</div>
            </div>
            ) : null}
        </div>
        <div className="col-span-12 lg:col-span-4">
            {/* Render payment Frequency */}
            {profile.expected_hourly_rate ? (
            <div className="w-full text-sm font-semibold text-black-1">
                <div className="text-black-2 text-xs font-normal">PAYMENT FREQUENCY</div>
                <div className="mt-1">
                    <Select
                        name="paymentFrequency"
                        value={paymentType}
                        getChange={(e) => 
                        onChangeEvent(e, profile.id)
                        }
                        paymentTypeList={paymentTypeList}
                    />
                </div>
            </div>
            ) : null}
        </div>
      </div>

    </div>
  );
}
